module.exports = __webpack_public_path__ + "img/plane-big.65912c05.png";